export function itemOccurrences(item) {
  return item && item
    .reduce(
      (
        acc,
        {id, preset, occurrences, timezone, productVariant, optionValues}
      ) =>
        occurrences
          .map((occurrence) => ({
            id,
            preset,
            occurrence,
            timezone,
            productVariant,
            optionValues,
          }))
          .concat(acc),
      []
    )
    .sort(
      (a, b) =>
        Date.parse(a.occurrence) - Date.parse(b.occurrence) ||
        a.productVariant.id - b.productVariant.id
    );
}



// WEBPACK FOOTER //
// ./utils/itemOccurrences.js